//按首字母进行排序，并分类

let FirstPin = ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "W", "X",
  "Y", "Z"
]
let pinyin = require('js-pinyin');

function orderByFirstPin(arr, orderKey) {
  let keyWordArr = []
  keyWordArr = arr.map(item => {
    //拿到关键字
    let keyword = item[orderKey]
    //取关键字第一个字的首字母
    let firstPin = pinyin.getCamelChars(keyword).substring(0, 1)
    item.first = firstPin
    return item
  })
  let keywordObj = {}
  FirstPin.forEach(item => {
    keywordObj[item] = keyWordArr.filter(item2 => item2.first == item)
  })
  return keywordObj
  //this.keyWordObj = keywordObj
}

module.exports = orderByFirstPin



// WEBPACK FOOTER //
// ./src/util/oderByFirstPin.js